import React from "react";

const VideoItem = ({ onVideoSelect, video }) => {
  console.log(onVideoSelect);
  return (
    <div
      className="item"
      onClick={() => {
        onVideoSelect(video);
        // onVideoSelect = video;
        console.log(onVideoSelect);
      }}
    >
      <div className="list_container">
        <img
          className="image_thumbnail"
          // src="https://images.unsplash.com/photo-1555797487-a1f30b5d8d55?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1189&q=80"
          src={video.snippet.thumbnails.medium.url}
          alt=""
        />
        <b>
          {/* How to tell you are cool How to tell you are cool How to tell you are */}
          {video.snippet.title}
        </b>
      </div>
    </div>
  );
};

export default VideoItem;
